<div class="wrapper mat-ctrl" [ngClass]="{'enable-empty': manageLineService.callCounter == 0}">
<div class="row">
    <div class="col-12 col-sm-12 col-md-8 mb-4 enable-empty">
        <mat-form-field class="w100">
            <mat-label>{{authoringContentData?.reasonChangeTxt}}</mat-label>
            <mat-select [formControl]="reasonValue" [(ngModel)]="selectedReason">
                <mat-option *ngFor="let reason of msidnChangeReasonData" [value]="reason.description" (click)="selectReason(reason)">
                    {{reason.description}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <span  class="npaErrorMsg small-text d-flex text-danger pt-2" *ngIf="this.reasonError"  >
            <strong>{{reasonErrorMessage}}</strong>
          </span>
    </div>
</div>
<div class="row">
    <div class="col-12 col-sm-12  mb-3" [ngClass]="isNpaNpxEnable && !singleSetting || (assignAll==authoringContentData?.assignAll && !singleSetting) ? 'col-md-3' :'col-md-4'">
        <mat-form-field  class="w100">
            <mat-label>{{authoringContentData?.chooseNumberTxt}}</mat-label>
            <mat-select [formControl]="zipCode" [(ngModel)]="selectedChooseNumberBy">
                <mat-option *ngFor="let items of changeNumberByDD" [(value)]="items.name" (click)="chooseNumberBy(items)">
                    {{items.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="col-12 col-sm-12 col-md-4 mb-3">
        <form class="example-form">
            <mat-form-field class="example-full-width w100">
                <mat-label>{{authoringContentData?.preferredareCodeTxt}} {{chooseNumberByPlaceholder ? chooseNumberByPlaceholder : 'Area Code' }}</mat-label>
                <input matInput
                (blur)="NpaNxxLookup($event)" (input)="clearErrors($event)" [formControl]="areaCodeValue" type='number'  onkeydown="javascript: return event.keyCode == 69 ? false : true"
                [maxLength]="areaCodeValidation">
                <span  class="npaErrorMsg small-text d-flex text-danger" *ngIf="isnpxErrorMsgEnable"  >
                    {{errorMessage}}
                </span>
            </mat-form-field>
        </form>
    </div>
    <div class="col-12 col-sm-12 col-md-5 mb-3">
        <mat-form-field class="w100" *ngIf="isNpaNpxEnable && !singleSetting || assignAll==authoringContentData?.assignAll && !singleSetting">
            <mat-label>{{authoringContentData?.preferredNxx}}</mat-label>
            <mat-select 
                [formControl]="npxNpaValue"
                (selectionChange)="requestedBody($event)" >
                <mat-option *ngFor="let item of npaNpxResponse" [value]="item.npaNxx">
                    {{item.npaNxx | NpaNpxPipe }} ({{item.availableCount}} {{authoringContentData?.availableLines}})
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-12" *ngIf="isVisibleLookUpField">
        <div class="row" *ngFor="let list of lookUpFieldArray,let idx =index">
            <div class="col-12 col-sm-12 mb-3 col-md-4">
                <mat-form-field class="w100">
                    <mat-label>{{authoringContentData?.chooseNumberTxt}}</mat-label>
                    <mat-select [(ngModel)]="list.zipCodes"
                        name='zipCodes'>
                        <mat-option *ngFor="let items of changeNumberByDD" [(value)]="items.name" (click)="chooseNumberBy(items,idx)">
                            {{items.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-12 col-md-4 mb-3">

                <form class="example-form">
                    <mat-form-field class="example-full-width w100">
                        <mat-label>{{authoringContentData?.preferredareCodeTxt}} {{list.zipCodes ? list.zipCodes : 'Area Code' }}</mat-label>
                        <input matInput
                            (blur)="NpaNxxLookup($event,idx)" (input)="clearErrors($event,idx)" name='areaCodeValues' type='number' onkeydown="javascript: return event.keyCode == 69 ? false : true"
                            [(ngModel)]="list.areaCodeValues" [maxLength]="list.areaCodeValidation">
                        <span  class="npaErrorMsg small-text d-flex text-danger" *ngIf="list.isnpxErrorMsgEnable"  >
                            {{list.errorMessage}}
                        </span>
                    </mat-form-field>
                </form>

            </div>

            <div class="col-12 col-sm-6 col-md-4 mb-3 d-flex align-items-center">
                <span class="text-magenta xsmall font-tele-hal" (click)="lookUpFieldRemover(list.areaCodeValues,idx)">{{authoringContentData?.btnRemoveTxt}}</span>
            </div>
        </div>
    </div>
    <div class="col-12 m-b-15" *ngIf="singleSetting"><span class="text-magenta font-tele-hal" (click)="lookUpFieldUpdater()">
        {{authoringContentData?.lookupMoreNum}}</span></div>
    <div class="col-12">
        <div class="row" *ngIf="isNpaNpxEnable && singleSetting">

            <div class="col-12 mb-2 ">

                <div class="row">
                    <div class="col-7 ">
                        <span class="mb-2 font-tele-hal block">
                            {{npaNpxResponse?.length}} {{authoringContentData?.txtNXX}} {{areaNumberCount}} {{authoringContentData?.txtAreaCode}}
                        </span>
                    </div>
                    <div class="col-5 ">
                        <span class="mb-2 text-right font-tele-hal block text-magenta" (click)="multiSelectCheckbox()">
                            {{selectToggle ? authoringContentData?.selectAll : authoringContentData?.unSelectAll }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 mb-1  ">
                <div class="col-12  border scrollHeight">
                    <div class="row border-bottom p-2 " *ngFor="let item of npaNpxResponse">

                        <div class="col-1 multiLineCheckBox">
                            <mat-checkbox (change)="updateSelectedLines($event, item)" [(ngModel)]="item.isLineSelected"></mat-checkbox>

                        </div>
                        <div class="col-3">
                            <span class="small">
                                {{item.npaNxx | NpaNpxPipe }}
                            </span> </div>

                        <div class="col-8">
                            <span class="small text-gray">
                                {{item.availableCount}} {{authoringContentData?.availableLines}}
                            </span> </div>
                    </div>
                </div>

                <span class="xsmall block mt-2 text-gray">
                    {{multiSelectedNpa.length}} selected ({{totalMultiLinesSelected}}
                    {{authoringContentData?.availableLines}})
                </span>
            </div>

        </div>
    </div>

    <div class="col-12 mb-1">
        <p *ngIf="enableMsisdnChangeValidatorErrorMsg" class="text-danger">{{msisdnChangeValidatorErrorMsg}}</p>
    </div>
</div>

<div class="row mt-3" *ngIf="singleSetting">
    <div class="col-12">
        <button id="tmo-next_1" class="tmo-nextBtn primary_btn next_btn" type="button" (click)="singleSettingPopulateData()"
            [disabled]="!enableNextSetting">{{authoringContentData?.btnNextTxt}}</button>
    </div>
</div>
</div>
